module.exports = __webpack_public_path__ + "static/media/salat.48675e4b.png";